<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Log In</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.min]"
                :error-messages="feedback"
                label="E-mail"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="Password"
                label="Password"
                counter
                @keyup.enter.native="login"
                @click:append="show1 = !show1"
              ></v-text-field>
              <p v-if="feedback" class="red-text center">{{ feedback }}</p>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="pa-3 ma-1" @click="login">submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import firebase from "firebase/app";
import "firebase/auth";
import db from "@/fb";
import { store } from "@/fb";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      alias: "",
      feedback: null,
      slug: null,
      show1: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        alias_min: (v) => v.length >= 4 || "Min 4 characters",
      },
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        this.feedback = null;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() =>
            db
              .collection("users")
              .doc(firebase.auth().currentUser.uid)
              .get()
              .then((doc) => {
                store.CurrentCampaign = doc.data().CurrentCampaign;
              })
              .then(this.$router.push({ name: "Campaign" }))
          )
          .catch((err) => {
            this.feedback = err.message;
          });
      } else {
        this.feedback = "Please fill in both fields";
      }
    },
  },
};
</script>

<style>
</style>